module.exports = __webpack_public_path__ + "img/sub-title-1.3638e918.png";